import { cn } from '@/lib/utils';

export type StepsProgressProps = {
  current: number;
  total: number;
};

export function StepsProgress({ current, total }: StepsProgressProps) {
  return (
    <div
      className="flex gap-1.5"
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={total}
      aria-valuenow={current}
      aria-label={`Passo ${current} de ${total}`}
    >
      {Array.from({ length: total }, (_, i) => {
        const segment = i + 1;
        const filled = segment <= current;
        return (
          <span
            key={segment}
            className={cn(
              'h-1.5 flex-1 rounded-full transition-colors duration-300',
              filled ? 'bg-primary' : 'bg-border',
            )}
          />
        );
      })}
    </div>
  );
}
